import { FC, useEffect, useState } from 'react';
import Highcharts, { Options, SeriesLineOptions } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import DarkTheme from 'highcharts/themes/high-contrast-dark';
import LightTheme from 'highcharts/themes/high-contrast-light';
import { useUi } from 'hooks/useUi';

interface SimpleLineGraphProps {
    series: SeriesLineOptions[];
    options?: Options;
    highcharts?: typeof Highcharts;
}

const SimpleLineGraph: FC<SimpleLineGraphProps> = ({
    series,
    options,
    highcharts,
}) => {
    const [internalOptions, setInternalOptions] = useState<Options>({});
    const { ui } = useUi();

    // if anyone can figure out how to enable accessibility for Highcharts in TypeScript, please do so
    Highcharts.defaultOptions.accessibility = {
        enabled: false,
    };
    if (!!highcharts)
        highcharts.defaultOptions.accessibility = {
            enabled: false,
        };

    // Set graph theme based on user's color theme.
    useEffect(() => {
        if (ui.theme === 'dark') DarkTheme(Highcharts);
        else LightTheme(Highcharts);
    }, [ui.theme]);

    useEffect(() => {
        setInternalOptions({
            chart: {
                type: 'line',
                height: '100%',
            },
            xAxis: {
                type: 'datetime',
            },
            yAxis: {
                title: {
                    text: '',
                },
            },
            title: { text: '' },
            credits: { enabled: false },
            series,
            ...options,
        });
    }, [series, options]);

    return (
        <div data-testid="SimpleLineGraph" style={{ height: '100%' }}>
            <HighchartsReact
                highcharts={highcharts ?? Highcharts}
                options={internalOptions}
            />
        </div>
    );
};

export default SimpleLineGraph;
